import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { DataService } from './../data.service';
import { HelperService } from './../helper.service';
// import { Racer } from './racerMap';
// import { NgbdSortableHeader, SortEvent } from './../sortable.directive';

@Component({
    // selector: 'app-racers, ngbd-table-complete',
    selector: 'app-racers',
    templateUrl: './racers.component.html',
    styleUrls: ['./racers.component.css']
})
export class RacersComponent implements OnInit {

    constructor(
        public dataService: DataService,
        public helperService: HelperService,
        private fb: FormBuilder
    ) { }

    public mode: string = "browse"; // edit & create are alternative options.
    public viewAllRacers: boolean = false;
    public yobOptions: any = [];
    public minAge: number = 18;
    public maxAge: number = 84;
    public filter = new FormControl('');
    public genderOptions: any = [{label: "Female", value: "F"}, {label: "Male", value: "M"}];

    public racerForm: any = this.fb.group({
        alternativeContactEmail: "",
        alternativeContactName: "",
        alternativeContactPhone: "",
        backyard2023: this.fb.group({
            confirmationNo: 0,
            bibNumber: "0",
            registered: false,
            registeredDate: ""
        }),
        backyard2022: this.fb.group({
            confirmationNo: 0,
            bibNumber: "0",
            registered: false,
            registeredDate: "",
            laps: []
        }),
        backyard2021: this.fb.group({
            confirmationNo: 0,
            bibNumber: "0",
            registered: false,
            registeredDate: "",
            laps: []
        }),
        city: "",
        country: "",
        created: "",
        displayName: "",
        docType: "racer",
        doubleDown2023: this.fb.group({
            confirmationNo: 0,
            bibNumber: "0",
            registered: false,
            registeredDate: "",
            division: ""}), // solor - relay -- // TODO - how to handle relay teams???
        laps: this.fb.array([]),
        email: "",
        emailSubscribed: false,
        firstName: "",
        gender: "",
        lastName: "",
        mainPhone: "",
        state: "",
        streetAddress: "",
        profileImageUrl: "",
        updated: "",
        yob: 2000,
        zip: "",
    });

    ngOnInit(): void {
        // this.getAllRacers();
        this.buildYobOptions();
        // console.log(this.dataService.racers);
        if (this.dataService.racers.length == 0) {
            this.dataService.getAllRacers();
        }
        
    }

    public addRacer(){
        this.mode = "create";
        this.racerForm.setValue({
            alternativeContactEmail: "",
            alternativeContactName: "",
            alternativeContactPhone: "",
            backyard2023: {
                confirmationNo: 0,
                bibNumber: "0",
                registered: false,
                registeredDate: ""
            },
            backyard2022: {
                confirmationNo: 0,
                bibNumber: "0",
                registered: false,
                registeredDate: "",
                laps: []
            },
            backyard2021: {
                confirmationNo: 0,
                bibNumber: "0",
                registered: false,
                registeredDate: "",
                laps: []
            },
            city: "",
            country: "",
            created: "",
            displayName: "",
            docType: "racer",
            doubleDown2023: {
                confirmationNo: 0,
                bibNumber: "0",
                registered: false,
                registeredDate: "",
                division: ""},
            laps: [],
            email: "",
            emailSubscribed: false,
            firstName: "",
            gender: "",
            lastName: "",
            mainPhone: "",
            state: "",
            streetAddress: "",
            profileImageUrl: "",
            updated: "",
            yob: 2000,
            zip: "",
        })
    }

    public editRacer(){
        this.mode = "edit";
    }

    public browseRacers(){
        this.mode = "browse";
    }

    // re-sorts just the Backyard racers
    // initial sort occurs by bib on data load.
    public sortRacers(){
        console.log('sorting racers by Bib Number for the 2023 race.');
        this.dataService.racers.sort(function (a, b) {            
            return parseInt(a.backyard2023.bibNumber) - parseInt(b.backyard2023.bibNumber);
        });
    }

    public editRacerFormBuild(racerDoc) {
        console.log("editRacerFormBuild for racerDoc -> ");
        console.log(racerDoc);
        if (this.dataService.appMode == 'viewer'){
            return false;
        } else {
            this.racerForm.patchValue({
                alternativeContactEmail: racerDoc.alternativeContactEmail,
                alternativeContactName: racerDoc.alternativeContactName,
                alternativeContactPhone: racerDoc.alternativeContactPhone,
                backyard2023: this.fb.group({
                    confirmationNo: 0,
                    bibNumber: "0",
                    registered: false,
                    registeredDate: ""}),
                city: racerDoc.city,
                country: racerDoc.country,
                created: racerDoc.created,
                displayName: racerDoc.displayName,
               // doubleDown2023: this.fb.group({
               //     confirmationNo: 0,
               //     bibNumber: "0",
               //     registered: false,
               //     registeredDate: "",
               //     division: ""}),
                laps: racerDoc.laps,
                email: racerDoc.email,
                emailSubscribed: racerDoc.emailSubscribed,
                firstName: racerDoc.firstName,
                gender: racerDoc.gender,
                lastName: racerDoc.lastName,
                mainPhone: racerDoc.mainPhone,
                state: racerDoc.state,
                streetAddress: racerDoc.streetAddress,
                profileImageUrl: racerDoc.profileImageUrl,
                updated: new Date(),
                yob: racerDoc.yob,
                zip: racerDoc.zip,
            });
            if (racerDoc.backyard2021){
                this.racerForm.patchValue({
                    backyard2021: racerDoc.backyard2021
                });
            }
            if (racerDoc.backyard2022) {
                this.racerForm.patchValue({
                    backyard2022: racerDoc.backyard2022
                });
                console.log(this.racerForm);
            }
            if (racerDoc.backyard2023) {
                this.racerForm.patchValue({
                    backyard2023: racerDoc.backyard2023
                });
            } else {
                this.racerForm.get('backyard2023').setValue(({
                    confirmationNo: 0,
                    bibNumber: "0",
                    registered: false,
                    registeredDate: ""
                }))
            }
            if (racerDoc.doubleDown2021){
                this.racerForm.patchValue({
                    doubleDown2021: racerDoc.doubleDown2021
                })
            }
            /**if (racerDoc.doubleDown2022) {
                this.racerForm.patchValue({
                    doubleDown2022: racerDoc.doubleDown2022
                })
            } else {
                this.racerForm.get('doubleDown2022').setValue({
                    confirmationNo: 0,
                    bibNumber: "0",
                    registered: false,
                    registeredDate: "",
                    division: ""
                })
            } */
            console.log(this.racerForm);
            this.mode = "edit";
        }
    }

    public saveRacer(){
        console.log('request to save/update the racer document....');
        let racerDoc = this.racerForm.value;
        racerDoc.created = new Date();
        console.log(racerDoc);
        let scope = this;
        if (this.mode == "create"){
            scope.dataService.racers.push(racerDoc);
            scope.dataService.createRacer(racerDoc).subscribe(res => {
                // console.log(res);
                // console.log("done with the create racer");
                scope.mode = "browse";
            })
        } else {
            // TODO: get only the touched elements and shove those over...
            // console.log(this.racerForm); // racer form.
            let updates: any = {updated: new Date()};
            // apply the updates to the racers array of racers
            for (let i = 0; i < scope.dataService.racers.length; i++){
                if (scope.dataService.racers[i].email == racerDoc.email){
                    scope.dataService.racers[i] = racerDoc; // apply the updates one by one here...
                    // update updates object & update at this point
                    for (let x in scope.racerForm.controls){
                        if (this.racerForm.controls[x].touched){
                            // console.log("found  touched element -> ");
                            // console.log(scope.racerForm.controls[x]);
                            scope.dataService.racers[i][x] = scope.racerForm.controls[x].value;
                            updates[x] = scope.racerForm.controls[x].value;
                        }
                    }
                    if (racerDoc.backyard2023.bibNumber) {
                        scope.dataService.racers[i].backyard2023 = racerDoc.backyard2023;
                        scope.dataService.currentYearBackyardRacers.push(scope.dataService.racers[i]);
                    }
                    // scope.dataService.racers[i].backyard2021 = racerDoc.backyard2021;
                    // scope.dataService.racers[i].doubleDown2021 = racerDoc.doubleDown2021;
                    console.log("here's the dataService version of the racer that was just saved....");
                    console.log(scope.dataService.racers[i]);
                }
            }
            setTimeout(function(){
                scope.dataService.updateRacer(scope.racerForm.value.email, updates).subscribe(res => {
                    // console.log(res);
                    // console.log("done with the update racer");
                    scope.mode = "browse";
                })
            }, 250);
        }
    }

    public archiveLaps(racer) {
        let scope = this;
        let updates: any = { updated: new Date() };
        updates.backyard2022 = racer.backyard2022;
        updates.backyard2022.laps = racer.laps;
        updates.laps = [];
        
        setTimeout(function () {
            console.log("looking for an email here -> " + racer.email);
            console.log(updates);
            scope.dataService.updateRacer(racer.email, updates).subscribe(res => {
                alert("Laps have been set to Backyard2022 for " + racer.firstName + " " + racer.lastName);
            })
        }, 250);
    }

    private buildYobOptions(){
        let d = new Date();
        let i = (this.minAge - 1); // youngest will be 18 years old... need to adjust do that here.
        while (i < this.maxAge){ // allows for up to an 80 year old to be selected in here....
            this.yobOptions.push(d.getFullYear() - i);
            i++;
        }
    }

    public checkInRacer(racerDoc){
        racerDoc.checkedIn = !racerDoc.checkedIn;
        this.dataService.updateRacer(racerDoc.email, {checkedIn: racerDoc.checkedIn}).subscribe(res => {
            // console.log(res);
            // console.log("racer checked in/out");
        })
    }
}
